/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './especialty.reducer';

export const EspecialtyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const especialtyEntity = useAppSelector(state => state.especialty.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="especialtyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.especialty.detail.title">Especialty</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.especialty.id">Id</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.id}</dd>
          <dt>
            <span id="especialtyName">
              <Translate contentKey="tinyMedicRestApp.especialty.especialtyName">Especialty Name</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.especialtyName}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.especialty.active">Active</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="especilalty">
              <Translate contentKey="tinyMedicRestApp.especialty.especilalty">Especilalty</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.especilalty}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.especialty.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.especialty.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.especialty.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.modifiedBy}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.especialty.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.especialty.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.especialty.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.especialty.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{especialtyEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/especialty" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/especialty/${especialtyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EspecialtyDetail;
